import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  identityApiRef,
  microsoftAuthApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { azDevopsApiRef } from './api';
import { AzDevOpsClient } from './api/AzDevOpsClient';

export const azdevopsPlugin = createPlugin({
  id: 'azdevops',
  apis: [
    createApiFactory({
      api: azDevopsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        authApi: microsoftAuthApiRef,
        identityApi: identityApiRef,
      },
      factory: deps => new AzDevOpsClient(deps),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const AzdevopsPage = azdevopsPlugin.provide(
  createRoutableExtension({
    name: 'AzdevopsPage',
    component: () =>
      import('./components/MainComponent').then(m => m.MainComponent),
    mountPoint: rootRouteRef,
  }),
);
